import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import './registerServiceWorker'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueEditor from "vue2-editor"
import VueMeta from 'vue-meta'
import vGoogleTranslate from 'v-google-translate';

Vue.use(vGoogleTranslate)
Vue.use(VueMeta)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueEditor)

Vue.component('v-select', vSelect)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
